import React from "react"
import classNames from "classnames"

import { Icon } from "web/components"

const sizeStyles = {
  tiny: "w-6 h-6",
  small: "w-7 h-7",
  normal: "w-8 h-8",
  large: "w-9 h-9",
}

export default function IconButton({
  id,
  testId,
  size = "normal",
  active,
  disabled,
  onClick = () => {},
  className = "",
  as = "button",
  ...rest
}) {
  const buttonClassName = classNames(
    "rounded flex items-center justify-center",
    sizeStyles[size],
    {
      "bg-primary-10": active,
      "hover:bg-primary-10 cursor-pointer": !disabled,
      "text-neutral-7 cursor-default": disabled,
    },
    className
  )

  const handleOnClick = () => {
    if (disabled) return
    onClick()
  }

  const props = {
    id,
    "data-testid": testId,
    onClick: handleOnClick,
    className: buttonClassName,
  }

  return React.createElement(as, props, <Icon {...rest} />)
}
